import React from 'react';
import './HoverActions.scss';
import { Button, Tooltip } from 'antd';
import DownloadLogsAction from 'components/DownloadLogsAction/DownloadLogsAction';
import SignedURLButton from 'components/SignedURLButton/SignedURLButton';
import SparkLogButton from 'components/SparkLogButton/SparkLogButton';
import { SparkJobStatuses } from 'types/types';
import { CodeOutlined, InfoCircleOutlined } from '@ant-design/icons';

type HoverActionsProps = {
  tableName: string;
  sparkJobID: string;
  isDownloadLogsBtnDisabled: boolean;
  clusterUrl: string;
  sparkJobStatus: SparkJobStatuses;
  sparkAppID: string;
  clusterName: string;
  schemaName: string;
  clusterPrefix: string;
  setPropertiesOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setCodeOpen: React.Dispatch<React.SetStateAction<boolean>>;
  jobPropOpened: boolean;
  jobCodeOpened: boolean;
};
function HoverActions({
  tableName,
  sparkJobID,
  isDownloadLogsBtnDisabled,
  clusterUrl,
  sparkJobStatus,
  sparkAppID,
  clusterName,
  schemaName,
  clusterPrefix,
  setPropertiesOpen,
  setCodeOpen,
  jobPropOpened,
  jobCodeOpened,
}: HoverActionsProps) {
  return (
    <>
      <article className="hover-action__wrapper">
        <span className="hover-action__btn-wrapper--hide">
          <DownloadLogsAction
            jobId={sparkJobID}
            showText={false}
            btnSize="middle"
            isDisabled={isDownloadLogsBtnDisabled}
            key={sparkJobID}
          />
        </span>
        <span className="hover-action__btn-wrapper--hide">
          <SparkLogButton
            clusterUrl={clusterUrl}
            jobStatus={sparkJobStatus}
            sparkAppID={sparkAppID}
            showText={false}
            btnSize="middle"
          />
        </span>
        <span className="hover-action__btn-wrapper--hide">
          <SignedURLButton
            tableName={tableName}
            clusterName={clusterName}
            schema={schemaName}
            jobId={sparkJobID}
            prefix={clusterPrefix}
            showText={false}
            btnSize="middle"
          />
        </span>
        <span className="hover-action__btn-wrapper--hide">
          <Tooltip title={`View Job Code`}>
            <Button
              className="download-logs-action__btn"
              onClick={() => {
                setCodeOpen(!jobCodeOpened);
                setPropertiesOpen(false);
              }}
              icon={<CodeOutlined />}
              size="middle"></Button>
          </Tooltip>
        </span>
        <span className="hover-action__btn-wrapper--hide">
          <Tooltip title={`View Job Properties`}>
            <Button
              className="download-logs-action__btn"
              onClick={() => {
                setPropertiesOpen(!jobPropOpened);
                setCodeOpen(false);
              }}
              icon={<InfoCircleOutlined />}
              size={'middle'}></Button>
          </Tooltip>
        </span>
      </article>
    </>
  );
}

export default HoverActions;
